import { useRecoilState, useRecoilValue } from 'recoil'
import { COLOR } from 'src/service/utils/constant/color'
import closeButton from 'src/assets/images/closeButton.png'

import {
  MVNOPopupWrap,
  ModalBox,
  ModalWrap,
  PopupLayer,
  TermsCheckBox,
} from 'src/styles/styledcomponent/component/common'
import { CustomButton } from 'src/styles/styledcomponent/views/RopForm/JoinSubmit'
import useWindowDimensions from 'src/hooks/useWindowDimensions'
import { MvmoTermsState, MvnoCheckValue, RecoilStateList, uiData } from 'src/recoil/common'
import useAPI from 'src/hooks/useAPI'
import { useParams } from 'react-router'
import { PramsKeys } from 'src/types/type'

const MVNOModal = (props: any) => {
  const { submit } = props
  const mvnoTermsData = useRecoilValue(MvmoTermsState)
  const [mvnoCheckValue, setMvnoCheckValue] = useRecoilState(MvnoCheckValue)
  const { width } = useWindowDimensions()
  const certInput = document.getElementById('certInput')
  const [
    {
      layoutsConfirm: { submitBtn },
    },
  ] = useRecoilState(uiData)
  const { pcode } = useParams<PramsKeys>()
  const { TelType, PhoneNum } = useRecoilValue(RecoilStateList)
  const CertApi = useAPI('requestSendCertNumber')
  const { mutateAsync: getSendOtp } = CertApi.useSetMutation({
    Telecom: TelType,
    PNumber: PhoneNum,
    Pcode: pcode,
  })

  const acceptKTTerms = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMvnoCheckValue(e.target.checked)
  }

  const modalClose = () => {
    submit.toggle() //toggle
    setMvnoCheckValue(false)
  }
  const checkTermTrue = () => {
    if (!mvnoCheckValue) {
      if (window.confirm('서비스 이용을 위해 약관 동의가 필요합니다.\n모두 동의하시겠습니까?')) {
        submit.toggle()
        setMvnoCheckValue(true)
        submit.cert(getSendOtp)
      }
    } else {
      submit.toggle()
      submit.cert(getSendOtp)
    }
    if (certInput) {
      setTimeout(() => {
        certInput.focus()
      }, 1000)
    }
  }

  return (
    <ModalWrap toggle={submit.isOpen} zIndex={9990} width={`${width}px`}>
      <ModalBox onClick={(e: any) => e.stopPropagation()}>
        <PopupLayer>
          <MVNOPopupWrap className="popup_contents">
            <img src={closeButton} className="close-btn" alt="" onClick={modalClose} />
            <div className="top">
              <h4 className="description">
                KT MVNO(알뜰폰) 추가
                <br />
                약관 동의가 필요합니다.
              </h4>
              <h4 className="title">아래 약관 확인 후 동의해주세요.</h4>
            </div>
            <div className="terms-wrap">
              <div className="check-wrap">
                <input type="checkbox" id="terms-check" onChange={acceptKTTerms} />
                <TermsCheckBox htmlFor="terms-check" isChecked={mvnoCheckValue}>
                  <p
                    dangerouslySetInnerHTML={{ __html: decodeURIComponent(escape(atob(mvnoTermsData.TermsTitle))) }}
                  />
                  <i className="icon" />
                </TermsCheckBox>
              </div>
              <div className="terms-contents-wrap">
                <p
                  className="terms-contents"
                  dangerouslySetInnerHTML={{ __html: decodeURIComponent(escape(atob(mvnoTermsData.Terms))) }}
                />
              </div>
            </div>
            <CustomButton
              id="common_btn"
              color={COLOR.white}
              bgColor={submitBtn.backgroundColor}
              borderRadius={'5px'}
              width={width > 1200 ? '356px' : '328px'}
              height={'44px'}
              fontSize={'14px'}
              fontFamily={
                width > 1200 ? 'NanumSquareNeoHeavy, sans-serif' : 'NotoSansBold, sans-serif'
              }
              onClick={checkTermTrue}
            >
              <span>동의 및 인증번호 받기</span>
            </CustomButton>
          </MVNOPopupWrap>
        </PopupLayer>
      </ModalBox>
    </ModalWrap>
  )
}
export default MVNOModal
